export const csrf =
  document.querySelector("meta[name='csrf-token']")?.getAttribute('content') ||
  ''
